<template>
    <btn-hamburger class="btn-hamburger--concave" @click="$emit('click')"><slot /></btn-hamburger>
</template>

<script>
import BtnHamburger from "@/components/publish/styles/buttons/btn-hamburger.vue";

export default {
    props: {},
    components: {
        BtnHamburger,
    },
    data: () => {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.btn-hamburger--concave {
    ::v-deep{
        > span {
            width: 20px;
            margin-left: 4px;
            &::before,
            &::after{
                right: 0;
            }
        }
    }
}
@media (min-width:576px){
}
@media (min-width:768px){
}
@media (min-width:1024px){
}
@media (min-width:1200px){
    .btn-hamburger--concave {
        ::v-deep{
            > span {
                width: 24px;
                margin-left: 6px;
            }
        }
    }
}

</style>
